module.exports = __webpack_public_path__ + "media/images/top/mainimage01-1c4d310e21f7c35f55d0f39f59cafa3d.png";